export function includes(strA, strB) {
  if (typeof strA !== "string" || typeof strB !== "string") return false;

  return strA.toLowerCase().includes(strB.toLowerCase());
}

export function search(searchKey) {
  return new SearchUnit(searchKey);
}

class SearchUnit {
  constructor(searchKey) {
    this.values = [];
    this.searchKey = searchKey;
  }

  val(value) {
    if (typeof value !== "string") return this;
    this.values.push(value);
    return this;
  }

  any() {
    if (this.searchKey === null || this.searchKey === undefined) {
      return true;
    }

    if (typeof this.searchKey !== "string") {
      return false;
    }

    let unifiedKey = this.searchKey.toLowerCase();
    for (let i = 0; i < this.values.length; i++) {
      if (this.values[i].toLowerCase().includes(unifiedKey)) {
        return true;
      }
    }

    return false;
  }
}
